<template>
  <CustomPage title="索取发票">
    <div slot="content" class="content">
      <div class="text-sm mx-3" style="color: #666666">
        *如需增值税专用发票，需提前提交增票资质给工作人员 审核
      </div>
      <div class="flex text-sm mx-3">
        <div
          class="rounded-full py-1 px-3 mx-1"
          :class="type ? 'notactive' : 'active'"
          @click="
            () => {
              type = 0;
              $store.commit('settle/CHANGE_INVOICE_SETTING', {
                needInvoice: false,
              });
            }
          "
        >
          不需要发票
        </div>
        <div
          class="rounded-full py-1 px-3 mx-1"
          :class="type ? 'active' : 'notactive'"
          @click="type = 1"
        >
          增值税专用发票
        </div>
      </div>
      <div v-show="type" class="mb-20">
        <div class="lightshadow rounded p-3 m-3">
          <Form readonly>
            <Field
              v-model="form.companyName"
              label="单位全称"
              input-align="right"
            />
            <Field
              v-model="form.taxpayerNumber"
              label="单位税号"
              input-align="right"
            />
            <Field
              v-model="form.companyPhone"
              label="注册电话"
              input-align="right"
            />
            <Field
              v-model="form.companyAddress"
              label="注册地址"
              input-align="right"
            />
            <Field v-model="form.bankNo" label="银行账号" input-align="right" />
            <Field
              v-model="form.bankName"
              label="开户银行"
              input-align="right"
            />
          </Form>
        </div>
        <div class="lightshadow rounded p-3 m-3">
          <Field v-model="form.bankNo" label="开票项目" input-align="right" />
          <Field v-model="form.bankName" label="开票明细" input-align="right" />
        </div>
        <div class="lightshadow rounded p-3 m-3">
          <Cell center title="使用单独收票地址">
            <template #right-icon>
              <VSwitch
                v-model="useDependenceInvoiceAddress"
                active-color="#ee0a24"
                size="24"
              />
            </template>
          </Cell>
          <Cell
            v-show="useDependenceInvoiceAddress"
            title="收票地址"
            is-link
            @click="$router.push({ name: 'NeedInvoiceAddressList' })"
            :value="$store.state.settle.invoice.currentInvoiceAddress.name"
          />
        </div>
      </div>
      <div class="mb-6 absolute bottom-0 w-full">
        <Button
          v-show="type === 1"
          size="large"
          color="#E82237"
          round
          style="height: 40px; width: 80%; margin-left: 10%; margin-right: 10%"
          @click="apply"
          >提交申请</Button
        >
      </div>
      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from "@/components/custom-page.vue";
import CustomView from "@/components/custom-view.vue";
import { Form, Field, Switch as VSwitch, Cell, Button, Toast } from "vant";
import { getCustomerInvoice } from "@/api/setting/invoice";
export default {
  components: { CustomPage, CustomView, Form, Field, VSwitch, Cell, Button },
  data() {
    return { type: 0, form: {}, useDependenceInvoiceAddress: false };
  },
  created() {
    console.log("this.$route.params", this.$route.params);
    getCustomerInvoice(this.$store.state.user.customerId).then((res) => {
      if (res.data) {
        if (res.data.checkState !== 1) {
          Toast({
            message: "开票信息审核未通过",
            position: "center",
            duration: 1000,
          });
          this.$router.back();
        }
        this.form = res.data;
      } else {
        Toast({
          message: "没有可用的开票信息",
          position: "center",
          duration: 1000,
        });
        this.$router.back();
      }
    });
    if (this.$route.params.needInvoice) {
      this.type = 1;
      this.useDependenceInvoiceAddress =
        !!this.$route.params.useDependenceInvoiceAddress;
      this.$store.commit("settle/CHANGE_INVOICE_SETTING", {
        needInvoice: true,
        customerInvoiceId: this.$route.params.customerInvoiceId,
        useDependenceInvoiceAddress:
          !!this.$route.params.useDependenceInvoiceAddress,
      });
    }
  },
  methods: {
    apply() {
      this.$store.commit("settle/CHANGE_INVOICE_SETTING", {
        needInvoice: !!this.type,
        customerInvoiceId: this.form.id,
        useDependenceInvoiceAddress: this.useDependenceInvoiceAddress,
      });
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.notactive {
  background-color: #eeeeee;
  border: 1px solid #eeeeee;
}
.active {
  background-color: #fff0f1;
  color: #e82237;
  border: 1px solid #e82237;
}
</style>